import { magicNumbers } from 'utils';
import { excelExportResourcesFields } from './excelExportResourcesFields';
import { excelExportContentFields } from './excelExportContentFields';

export const excelExportInitialState = {
  step: 'step_1',
  title: '',
  page: '',
  platform: '',
  bulletinId: null,
  isModalOpen: false,
  isRandomSortEnabled: false,
  count: magicNumbers?.MIN_ROWS_FOR_EXPORT_EXCEL,
  selectedParams: [],
  limits: {
    data: [],
    loading: false,
    error: undefined,
  },
  export: {
    data: [],
    loading: false,
    error: undefined,
  },
  exportFormats: {
    xlsx: {
      title: 'xlsx',
      selected: true,
    },
    csv: {
      title: 'csv',
      selected: false,
    },
  },
  excelFields: {
    resource: excelExportResourcesFields,
    content: excelExportContentFields,
  },
};
